var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFemaleIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 24,
    viewBox: "0 0 16 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.92594 15.5833C4.91634 15.3168 3.08519 14.3136 1.80277 12.7767C0.520361 11.2397 -0.117604 9.28372 0.0178892 7.30419C0.153382 5.32465 1.05222 3.46931 2.53264 2.11336C4.01306 0.757408 5.96459 0.00203946 7.99257 3.64084e-06C10.023 -0.00191126 11.9783 0.751594 13.4619 2.10776C14.9455 3.46392 15.8465 5.32125 15.9821 7.30321C16.1178 9.28517 15.478 11.2434 14.1924 12.781C12.9069 14.3186 11.0718 15.3204 9.0592 15.5833V17.7391H14.3923V19.8261H9.0592V24H6.92594V19.8261H1.59281V17.7391H6.92594V15.5833ZM7.99257 13.5652C9.54845 13.5652 11.0406 12.9606 12.1408 11.8843C13.241 10.808 13.859 9.3482 13.859 7.82609C13.859 6.30398 13.241 4.84421 12.1408 3.76791C11.0406 2.69162 9.54845 2.08696 7.99257 2.08696C6.43669 2.08696 4.94454 2.69162 3.84437 3.76791C2.74419 4.84421 2.12612 6.30398 2.12612 7.82609C2.12612 9.3482 2.74419 10.808 3.84437 11.8843C4.94454 12.9606 6.43669 13.5652 7.99257 13.5652Z",
    fill: "url(#paint0_linear_10080_14028)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10080_14028",
    x1: -1.12,
    y1: 27.48,
    x2: 25.3871,
    y2: 9.36119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D38F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E827D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleIcon);
export default __webpack_public_path__ + "static/media/female_icon.dbcff123f4e6ebbda9a294cc0ec5c7de.svg";
export { ForwardRef as ReactComponent };